import { snapToStop } from './amountScale';

export { MAX_AMOUNT, MIN_AMOUNT } from './amountScale';

export function sanitiseAmount(raw: string | null | undefined): number | null {
  if (!raw) return null;
  const digits = raw.replace(/[^0-9]+/g, '');
  if (!digits) return null;

  const parsed = Number(digits);
  if (Number.isNaN(parsed)) return null;

  return snapToStop(parsed);
}
